import {HttpInterceptorFn} from '@angular/common/http';

export const headersInterceptor: HttpInterceptorFn = (req, next) => {
    // Kein Authorization-Header aus dem accessToken-Cookie mehr: das Cookie wird nur
    // einmal beim Login gesetzt und nie aktualisiert. Nach Ablauf der Keycloak-Access-
    // Token-TTL (z.B. 5 Minuten) war es dauerhaft veraltet, und AuthorizationMiddleware
    // nimmt bei vorhandenem Bearer-Header einen Zweig ohne Refresh-Logik - jeder Request
    // schlug danach permanent mit 401 fehl, obwohl die httpOnly-Session (die die Middleware
    // sonst nutzt und bei Bedarf automatisch erneuert) noch gültig war. Das Session-Cookie
    // wird vom Browser ohnehin automatisch mitgeschickt.
    const headers: Record<string, string> = {
        'pragma': 'no-cache',
        'cache-control': 'no-cache',
    };
    const clonedReq = req.clone({ setHeaders: headers });
    return next(clonedReq);
};